
import { Season } from './types';

export const SEASONS: Season[] = [
  {
    number: 16,
    theme: "Hearts on Fire",
    subtitle: "X6: The New Era",
    contestants: [
      {
        id: "tdi6PgBICe8",
        name: "Soundharya Shetty",
        image: "https://i.ytimg.com/vi/tdi6PgBICe8/hqdefault.jpg",
        videoUrl: "https://www.youtube.com/embed/tdi6PgBICe8",
        bio: "The powerhouse performer of Season 16. Known for her explosive personality and clear stand on villa politics, she is here to set the screen on fire.",
        tagline: "Fire in my soul, grace in my steps.",
        season: 16
      },
      {
        id: "2FZ_xVdrcAE",
        name: "Diksha Pawar",
        image: "https://i.ytimg.com/vi/2FZ_xVdrcAE/hqdefault.jpg",
        videoUrl: "https://www.youtube.com/embed/2FZ_xVdrcAE",
        bio: "A social media star turned reality diva. Diksha brings a mix of high-fashion glam and a 'no-nonsense' attitude to the new season.",
        tagline: "Unapologetically Glamorous.",
        season: 16
      },
      {
        id: "3mh3dU57GWc",
        name: "Akanksha Chaudhary",
        image: "https://i.ytimg.com/vi/3mh3dU57GWc/hqdefault.jpg",
        videoUrl: "https://www.youtube.com/embed/3mh3dU57GWc",
        bio: "A social media star turned reality diva. Akanksha brings a mix of high-fashion glam and a 'no-nonsense' attitude to the new season.",
        tagline: "Unapologetically Glamorous.",
        season: 16
      },
      {
        id: "hmwssoldyLQ",
        name: "Anisha Shinde",
        image: "https://i.ytimg.com/vi/hmwssoldyLQ/hqdefault.jpg",
        videoUrl: "https://www.youtube.com/embed/hmwssoldyLQ",
        bio: "A social media star turned reality diva. Anisha brings a mix of high-fashion glam and a 'no-nonsense' attitude to the new season.",
        tagline: "Unapologetically Glamorous.",
        season: 16
      },
      {
        id: "J3t72R9iJZw",
        name: "Anjali Schmuck ",
        image: "https://i.ytimg.com/vi/J3t72R9iJZw/hqdefault.jpg",
        videoUrl: "https://www.youtube.com/embed/J3t72R9iJZw",
        bio: "A social media star turned reality diva. Anjali brings a mix of high-fashion glam and a 'no-nonsense' attitude to the new season.",
        tagline: "Unapologetically Glamorous.",
        season: 16
      },
    ]
  },
  {
    number: 15,
    theme: "ExSqueeze Me Please",
    subtitle: "X5: The Villa of Secrets",
    contestants: [
      {
        id: "15-1",
        name: "Akriti Negi",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=400&h=600",
        videoUrl: "https://www.youtube.com/embed/SOf-1m2H6Xg",
        bio: "The triumphant winner of Season 15. A fierce Roadies veteran who dominated the villa with her sharp wit and an unbreakable bond with Jashwanth.",
        tagline: "The Unrivaled Queen of X5.",
        season: 15
      },
      {
        id: "15-2",
        name: "Anicka Sharma",
        image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=400&h=600",
        videoUrl: "https://www.youtube.com/embed/mKkX_00v7oU",
        bio: "The 'Traumatized' diva who wore her heart on her sleeve. Her intense connection with Siwet and her emotional journey made her a fan favorite.",
        tagline: "Elegance and Intensity.",
        season: 15
      },
      {
        id: "15-3",
        name: "Kashish Kapoor",
        image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&q=80&w=400&h=600",
        videoUrl: "https://www.youtube.com/embed/p_G20_k9q38",
        bio: "The mastermind who prioritized logic over sentiment, making one of the boldest moves in Splitsvilla history at the finale.",
        tagline: "Unapologetically Strategic.",
        season: 15
      }
    ]
  }
];
